import { render, staticRenderFns } from "./Onboarding.pug?vue&type=template&id=574a5ac7&scoped=true&lang=pug&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.scss?vue&type=style&index=0&id=574a5ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a5ac7",
  null
  
)

export default component.exports